/** @jsxImportSource @emotion/react */
import { Button } from '@mui/material'
import * as classes from './styles'

type Props = {
  previewDisabled: boolean
  submitDisabled: boolean
  onPreviewClick: () => void
}

export const FooterButtons = ({ onPreviewClick, previewDisabled, submitDisabled }: Props) => (
  <div css={classes.buttons}>
    <Button variant="outlined" color="blue" size="large" disabled={previewDisabled} onClick={onPreviewClick}>
      Preview Email
    </Button>

    <Button color="blue" type="submit" size="large" disabled={submitDisabled}>
      Save
    </Button>
  </div>
)
